<template>
  <div class="dsf_year_calendar_view">
    <div class="dsf_year_calendar_view_top">
      <el-row>
        <el-col :span="6">
          <div class="dsf_year_calendar_view_top_year">
            <el-select
              v-model="yearValue"
              placeholder="请选择"
              @change="chooseYears(yearValue)"
            >
              <el-option
                v-for="(item, index) in yearOptions"
                :key="'selectitem' + index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="dsf_year_calendar_view_top_month">
            <div class="top_month_left" @click="chooseMonth(month - 1)">
              <img
                :src="
                  require('_platform/assets/styles/themes/img/arrow-left-def.png')
                "
                alt
              />
            </div>
            <div class="top_month_middle">
              <el-select
                v-model="monthValue"
                placeholder="请选择"
                @change="chooseMonth(monthValue)"
              >
                <el-option
                  v-for="(item, index) in monthOptions"
                  :key="'selectitem' + index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="top_month_left" @click="chooseMonth(month + 1)">
              <img
                :src="
                  require('_platform/assets/styles/themes/img/arrow-right-def.png')
                "
                alt
              />
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="dsf_year_calendar_view_top_backtoday" v-if="!isArrange">
            <el-button class="backtoday_button" @click="backToday()">
              返回今天
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <table
      class="dsf_year_calendar_view_content"
      border="1"
      cellspacing="0"
      cellpadding="0"
      border-collapse="collapse"
    >
      <thead>
        <tr>
          <td class="c_content_header">星期日</td>
          <td class="c_content_header">星期一</td>
          <td class="c_content_header">星期二</td>
          <td class="c_content_header">星期三</td>
          <td class="c_content_header">星期四</td>
          <td class="c_content_header">星期五</td>
          <td class="c_content_header">星期六</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, indexH) in days" :key="'hang' + indexH">
          <td
            @click="controlArrange(dayItem)"
            @contextmenu.prevent="reset"
            @mouseenter="arrange(dayItem)"
            v-for="(dayItem, indexCell) in item"
            :class="{
              c_content_cell_noarrange: isArrange && !dayItem.isArrange,
              c_content_cell_arrange_select:
                isArrange &&
                arrangeArray.filter((d) => d.gregorian == dayItem.gregorian)
                  .length > 0,
            }"
            :key="'cell' + indexCell"
            class="c_content_cell"
          >
            <!-- 节假日背景 -->
            <div
              v-if="dayItem.isHoliday"
              class="c_content_cell_holidaybg"
            ></div>

            <!-- <div
              v-if="isArrange && dayItem.allow"
              class="c_content_cell_arrange"
            ></div> -->

            <!-- 当天样式 -->
            <div
              v-if="today > 0 && parseInt(dayItem.gregorian) == today"
              class="c_content_cell_todaybackground"
            ></div>
            <el-popover
              v-if="isArrange && dayItem.type_text"
              placement="top"
              title=""
              width="40"
              trigger="hover"
            >
              <div
                style="text-align: center; margin-bottom: 5px"
                v-for="(it, index) in dayItem.type_text.split('^')"
                :key="index"
              >
                {{ it }}
              </div>

              <div
                slot="reference"
                :class="
                  today > 0 && parseInt(dayItem.gregorian) == today
                    ? 'c_content_cell_day_white'
                    : 'c_content_cell_day'
                "
              >
                {{ dayItem.gregorian || "" }}
              </div>
            </el-popover>
            <div
              v-else
              :class="
                today > 0 && parseInt(dayItem.gregorian) == today
                  ? 'c_content_cell_day_white'
                  : 'c_content_cell_day'
              "
            >
              {{ dayItem.gregorian || "" }}
            </div>

            <div
              v-if="dayItem.holiday.length > 0"
              :class="
                today > 0 && parseInt(dayItem.gregorian) == today
                  ? 'c_content_cell_oldday_white'
                  : 'c_content_cell_oldday_yellow'
              "
            >
              {{ dayItem.lunar || "" }}
            </div>

            <div
              v-else
              :class="
                today > 0 && parseInt(dayItem.gregorian) == today
                  ? 'c_content_cell_oldday_white'
                  : 'c_content_cell_oldday'
              "
            >
              {{ dayItem.lunar || "" }}
            </div>
            <div
              v-if="
                !isArrange &&
                  dayItem.gregorian > 0 &&
                  (!openCustomFun || pageUrl !== '')
              "
              :class="
                dayItem.isHoliday
                  ? 'c_content_cell_bottom_cancel'
                  : 'c_content_cell_bottom'
              "
              @click.stop="changeHolidayStatus(indexH, indexCell, dayItem)"
            >
              {{
                openCustomFun
                  ? "设置"
                  : dayItem.isHoliday
                    ? "取消假日"
                    : "设为假日"
              }}
            </div>
            <!-- <el-popover
              placement="right"
              :width="
                dayItem.forbidDtos && dayItem.forbidDtos.length < 10 ? 255 : 500
              "
              trigger="hover"
            >
              <div
                class="forbid-arrange-vertical"
                v-if="dayItem.forbidDtos && dayItem.forbidDtos.length < 10"
              >
                <div
                  class="forbid-arrange-vertical_item forbid-common"
                  v-for="(item, i) in transFormData(dayItem.forbidDtos)"
                  :key="i"
                >
                  <div>
                    <span>禁排类型</span>
                    <span>{{ item.obj }}</span>
                  </div>
                  <div>
                    <span>{{ item.obj }}名字</span>
                    <span>{{ item.resource.text }}</span>
                  </div>
                  <div>
                    <span>禁排日期</span>
                    <span>{{ item.date }} {{ item.timeName }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="forbid-arrange-horizonta">
                <div
                  class="forbid-arrange-horizonta_item forbid-common"
                  v-for="(item, i) in transFormData(dayItem.forbidDtos)"
                  :class="{ even: i % 2 == 0 }"
                  :key="i"
                >
                  <div>
                    <span>禁排类型</span>
                    <span>{{ item.obj }}</span>
                  </div>
                  <div>
                    <span>{{ item.obj }}名字</span>
                    <span>{{ item.resource.text }}</span>
                  </div>
                  <div>
                    <span>禁排日期</span>
                    <span>{{ item.date }} {{ item.timeName }}</span>
                  </div>
                </div>
              </div>
              v-show="dayItem.forbidDtos && dayItem.forbidDtos.length > 0"
            <div
              slot="reference"
              class="c_content_cell_dot"
                
            >123</div>
            </el-popover> -->
          </td>
        </tr>
      </tbody>
    </table>

    <div class="dsf_year_calendar_view_bottom">
      <div class="dsf_year_calendar_view_bottom_notice">
        <div class="notice_color_block"></div>
        今日
      </div>
      <div class="dsf_year_calendar_view_bottom_notice">
        <div class="notice_color_block_holiday"></div>
        假日
      </div>
      <div class="dsf_year_calendar_view_bottom_notice">
        <div class="notice_color_block_workday"></div>
        工作日
      </div>
    </div>
  </div>
</template>

<script>
import {
  sloarToLunar,
  getYearMonthDay,
  getNongliDay,
} from "./computedLunarDate.js";
export default dsf.component({
  ctrlCaption: "万年历",
  name: "DsfYearCalendar",
  mixins: [$mixins.control],
  props: {
    saveUrl: {
      // 设置数据接口
      type: String,
      default: "",
    },
    queryUrl: {
      // 查询数据接口
      type: String,
      default: "",
    },
    isReadOnly: {
      // 是否只读
      type: Boolean,
      default: true,
    },
    openCustomFun: {
      // 自定义数据设置页面
      type: Boolean,
      default: false,
    },
    yearOptions: {
      type: Array,
      default() {
        return [
          {
            value: 2018,
            label: "2018年",
          },
          {
            value: 2019,
            label: "2019年",
          },
          {
            value: 2020,
            label: "2020年",
          },
          {
            value: 2021,
            label: "2021年",
          },
          {
            value: 2022,
            label: "2022年",
          },
          {
            value: 2023,
            label: "2023年",
          },
        ];
      },
    },
    pageUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      yearValue: 2020,
      monthValue: 11,
      weekIndex: 0,
      monthOptions: [
        {
          value: 1,
          label: "1月",
        },
        {
          value: 2,
          label: "2月",
        },
        {
          value: 3,
          label: "3月",
        },
        {
          value: 4,
          label: "4月",
        },
        {
          value: 5,
          label: "5月",
        },
        {
          value: 6,
          label: "6月",
        },
        {
          value: 7,
          label: "7月",
        },
        {
          value: 8,
          label: "8月",
        },
        {
          value: 9,
          label: "9月",
        },
        {
          value: 10,
          label: "10月",
        },
        {
          value: 11,
          label: "11月",
        },
        {
          value: 12,
          label: "12月",
        },
      ],

      solarTerm: [
        "小寒",
        "大寒",
        "立春",
        "雨水",
        "惊蛰",
        "春分",
        "清明",
        "谷雨",
        "立夏",
        "小满",
        "芒种",
        "夏至",
        "小暑",
        "大暑",
        "立秋",
        "处暑",
        "白露",
        "秋分",
        "寒露",
        "霜降",
        "立冬",
        "小雪",
        "大雪",
        "冬至",
      ],
      sTermInfo: [
        0,
        21208,
        42467,
        63836,
        85337,
        107014,
        128867,
        150921,
        173149,
        195551,
        218072,
        240693,
        263343,
        285989,
        308563,
        331033,
        353350,
        375494,
        397447,
        419210,
        440795,
        462224,
        483532,
        504758,
      ],
      nStr1: ["日", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十"],
      nStr2: ["初", "十", "廿", "卅"],
      basejieri: {
        "0101": "元旦",
        "0214": "情人节",
        "0308": "妇女节",
        "0312": "植树节",
        "0401": "愚人节",
        "0501": "劳动节",
        "0504": "青年节",
        "0512": "护士节",
        "0601": "儿童节",
        "0701": "建党节",
        "0801": "建军节",
        "0910": "教师节",
        1001: "国庆节",
        1224: "平安夜",
        1225: "圣诞节",
      },
      year: 0,
      month: 0,
      today: 0,
      days: [],
      weeks: ["一", "二", "三", "四", "五", "六", "日"],
      todayDate: 0,
      isOpenArrange: false,
      arrangeArray: [], //可排和禁排数组 选中数组
      startDateTime: 0, // 可选时间戳范围
      endDateTime: 0, // 可选时间戳范围
    };
  },
  computed: {
    isArrange() {
      return !this.isReadOnly;
    },
  },
  created() {
    if (!this.isArrange) return;
    let query = this.queryString;
    this.termId = query["termId"];
    let startDate = query["startDate"];
    let endDate = query["endDate"];
    this.startDateTime = this.getTimeToMonth(startDate, "00:00:00");
    this.endDateTime = this.getTimeToMonth(endDate, "23:59:59");
    if (startDate && endDate) {
      let startYear = parseInt(startDate.split("-")[0]);
      let startMonth = parseInt(startDate.split("-")[1]);
      let endYear = parseInt(endDate.split("-")[0]);
      let n = endYear - startYear;
      let yearOptions = [];
      for (let i = 0; i <= n; i++) {
        yearOptions.push({
          value: parseInt(startYear + i),
          label: parseInt(startYear + i) + "年",
        });
      }
      this.yearOptions = yearOptions;
      this.year = startYear;
      this.month = startMonth;
      this.yearValue = startYear;
    }
  },
  mounted() {
    this.backToday();
  },
  methods: {
    getTimeToMonth(date, time, isTime) {
      return new Date(
        dsf.date.format(new Date(date), "yyyy-mm-dd " + time)
      ).getTime();
    },
    transFormData(forbidDtos) {
      if (!forbidDtos) return [];
      // 2 教室 1 老师 4 课程/
      return forbidDtos.map((d) => {
        switch (d.resourceType.value) {
        case "CONSTITUTOR":
          d.obj = "教师";
          break;
        case "PLACE":
          d.obj = "教室";
          break;
        case "SUBJECT":
          d.obj = "课程";
          break;
        }
        return d;
      });
    },
    controlArrange(dayItem) {
      if (!this.isArrange) return;
      if (dayItem.gregorian && dayItem.isArrange) {
        // 如果没有开启可排 则开启可排
        if (!this.isOpenArrange) {
          this.arrangeArray.push(dayItem);
          this.isOpenArrange = true;
        } else {
          this.isOpenArrange = false;
          // 做提交操作
          let addDate = [];
          this.arrangeArray.forEach((item) => {
            addDate.push(item.time);
          });

          let data = this.arrangeArray;
          //自定义视图
          if (this.openCustomFun) {
            this.$openDialog({
              title: "日期设置",
              width: "800px",
              height: "60vh",
              params: {
                path: this.pageUrl,
              },
              dialogArgs: {
                data,
              },
              btns: [],
            });
          } else {
            let timeDate = {
              timeDate: data.map((it) => it.time),
            };
            this.$http
              .post(
                `/calendar/cancelOrSetWeekByTimes`,
                JSON.stringify(timeDate),
                {
                  headers: {
                    "Content-Type": "application/json; charset=utf-8",
                  },
                }
              )
              .done(({ success }) => {
                if (success) {
                  dsf.layer.message("设置成功");
                  this.getDays();
                } else {
                  // 置空数据
                  this.isOpenArrange = false;
                  this.arrangeArray = [];
                  dsf.layer.message("设置失败", false);
                }
              });
          }
        }
      }
    },
    arrange(dayItem) {
      if (!this.isArrange) return;
      if (dayItem.gregorian && dayItem.isArrange) {
        if (this.isOpenArrange) {
          let index = this.arrangeArray.findIndex(
            (d) => d.gregorian === dayItem.gregorian
          );
          if (index > -1) {
            this.arrangeArray = this.arrangeArray.slice(0, index + 1);
          } else {
            this.arrangeArray.push(dayItem);
          }
        }
      }
    },
    reset() {
      // 清空数据
      this.isOpenArrange = false;
      this.arrangeArray = [];
    },
    // 获取当前月份所有公历日期及其农历日期
    getDays() {
      // 清空数据
      this.isOpenArrange = false;
      this.arrangeArray = [];

      this.monthValue = this.month;
      this.days = [];
      const time = new Date();
      time.setFullYear(this.year, this.month, 0);

      let totalDay = time.getDate();
      const firstDay = new Date(this.year, this.month - 1, 1); // 当月第一天
      const lastDay = new Date(this.year, this.month - 1, totalDay); // 当月最后

      // 获取星期中的第几天（0-6）(星期日-星期六)
      this.weekIndex = firstDay.getDay();

      this.yearValue = this.year;

      let _time =
        this.year + "-" + (this.month < 10 ? "0" + this.month : this.month);

      const lastWeekIndex = lastDay.getDay();
      let tempArr = [];
      for (let i = 1; i <= totalDay; i++) {
        if (i == 1 && this.weekIndex != 0) {
          for (let temp = 0; temp < this.weekIndex; temp++) {
            tempArr.push({
              gregorian: "",
              lunar: "",
              holiday: "",
              isHoliday: false,
            });
          }
        }
        // 设置的具体时间
        let arrangeTime = _time + "-" + (i < 10 ? "0" + i : i) + " 00:00:00";
        tempArr.push({
          isArrange: true,
          gregorian: i,
          time: arrangeTime,
          lunar: getYearMonthDay(this.year, this.month, i),
          holiday: "",
          isHoliday: false,
        });
        if (i == totalDay && lastWeekIndex != 6) {
          for (let temp = 0; temp < 6 - lastWeekIndex; temp++) {
            tempArr.push({
              gregorian: "",
              lunar: "",
              holiday: "",
              isHoliday: false,
            });
          }
        }
        if (tempArr.length == 7) {
          let weekArray = tempArr;
          this.days.push(weekArray);
          tempArr = [];
        }
      }
      if (this.days.length < 6) {
        for (let temp = 0; temp < 6 - this.days.length; temp++) {
          this.days.push([
            { gregorian: "", lunar: "", holiday: "", isHoliday: false },
            { gregorian: "", lunar: "", holiday: "", isHoliday: false },
            { gregorian: "", lunar: "", holiday: "", isHoliday: false },
            { gregorian: "", lunar: "", holiday: "", isHoliday: false },
            { gregorian: "", lunar: "", holiday: "", isHoliday: false },
            { gregorian: "", lunar: "", holiday: "", isHoliday: false },
            { gregorian: "", lunar: "", holiday: "", isHoliday: false },
          ]);
        }
      }
      this.requestHolidayData();
      // if (this.isArrange) this.requestArrangeData(); // 如果是可排组件
    },
    //改变年份
    chooseYears(state) {
      this.yearValue = state;
      this.year = state;
      if (
        new Date().getFullYear() === this.year &&
        new Date().getMonth() + 1 === this.month
      ) {
        this.today = this.todayDate;
      } else {
        this.today = 0;
      }

      this.getDays();
    },
    //改变月份
    chooseMonth(state) {
      if (state < 1 || state > 12) return;
      this.month = state;
      if (
        new Date().getFullYear() === this.year &&
        new Date().getMonth() + 1 === this.month
      ) {
        this.today = this.todayDate;
      } else {
        this.today = 0;
      }
      this.getDays();
    },
    //返回今天
    backToday() {
      this.todayDate = new Date().getDate();
      const now = new Date();

      this.year = now.getFullYear();
      this.month = now.getMonth() + 1;
      this.today = now.getDate();

      this.getDays();
    },
    confirm() {
      this.$emit("getLunarDate", this.selectDate);
    },
    getJQ(yyyy, MM, dd) {
      let mm = MM - 1;
      let solarTerms = "";
      //此方法可以获取该日期处于某节气
      var tmp1 = new Date(
        31556925974.7 * (yyyy - 1900) +
          this.sTermInfo[mm * 2 + 1] * 60000 +
          Date.UTC(1900, 0, 6, 2, 5)
      );
      var tmp2 = tmp1.getUTCDate();
      if (tmp2 == dd) {
        solarTerms = this.solarTerm[mm * 2 + 1];
      }
      tmp1 = new Date(
        31556925974.7 * (yyyy - 1900) +
          this.sTermInfo[mm * 2] * 60000 +
          Date.UTC(1900, 0, 6, 2, 5)
      );
      tmp2 = tmp1.getUTCDate();
      if (tmp2 == dd) {
        solarTerms = this.solarTerm[mm * 2];
      }
      return solarTerms;
    },
    getHoliday(data) {
      data.forEach((item) => {
        let tempTimeArr = item.time.split("-");
        if (tempTimeArr.length == 3) {
          let keyIndex = parseInt(tempTimeArr[2]) + this.weekIndex;
          let weekCount = parseInt((keyIndex - 1) / 7);
          let dayCount = (keyIndex - 1) % 7;
          if (this.days.length > 0) {
            this.days[weekCount][dayCount].isHoliday =
              item.is_work == 0 ? true : false;
            this.days[weekCount][dayCount].holiday = item.name || "";
            this.days[weekCount][dayCount].type_text = item.type_text || "";
            this.days[weekCount][dayCount].type_value = item.type_value || "";
            this.days[weekCount][dayCount].service_calendar_id =
              item.service_calendar_id || "";
          }
        }
      });
    },
    requestHolidayData() {
      let tempMonth = "";
      if (this.monthValue < 10) {
        tempMonth = "0" + this.monthValue;
      } else {
        tempMonth = "" + this.monthValue;
      }
      this.$http
        .get(
          "calendar/findHoliday",
          dsf.mix(
            {},
            {
              years: this.yearValue + "" + tempMonth,
            },
            this.queryString
          )
        )
        .done(({ success, data }) => {
          if (success) {
            this.getHoliday(data);
          }
        });
    },
    changeHolidayStatus(indexH, indexCell, dayItem) {
      dayItem = dsf.mix({}, dayItem);
      let tempMonth = "";
      if (this.monthValue < 10) {
        tempMonth = "0" + this.monthValue;
      } else {
        tempMonth = "" + this.monthValue;
      }
      let tempDay = "";
      if (parseInt(dayItem.gregorian) < 10) {
        tempDay = "0" + dayItem.gregorian;
      } else {
        tempDay = "" + dayItem.gregorian;
      }
      dayItem.__tempDay = tempDay;
      let id = dayItem.service_calendar_id || "";
      if (this.openCustomFun) {
        this.$openDialog({
          title: "日期设置",
          width: "800px",
          height: "60vh",
          params: {
            path: `${this.pageUrl}?isSimple=${true}&id=${id}&days=${
              dayItem.time
            }`,
          },
          btns: [],
        });
        // this.$openWindow({
        //   url: dsf.url.getWebPath(
        //     this.$replace(this.pageUrl, this.$expressParams(this, dayItem))
        //   ),
        // });
      } else {
        this.$http
          .post("calendar/cancelOrSetWeek", {
            time: this.yearValue + "-" + tempMonth + "-" + tempDay,
          })
          .done(({ success, data }) => {
            if (success) {
              this.days[indexH][indexCell].isHoliday = !this.days[indexH][
                indexCell
              ].isHoliday;
              dsf.layer.message("设置成功");
            } else {
              dsf.layer.message("设置失败", false);
            }
          });
      }
    },
  },
});
</script>
